<div class="kr-skeleton-wrapper kr-skeleton-wrapper--partial"><div class="kr-skeleton" v-for="n in size" :key="n"></div></div>